const tagsView = {
    name: 'tagsView',
    namespaced: true,
    state: {
        visitedViews: [],
        cachedViews: [],
    },
    mutations: {
        ADD_VISITED_VIEWS: (state, view) => {
            let firstLevel = view;

            // 只缓存一级路由，AppMain.vue中的router-view.body-container
            // eslint-disable-next-line
            if (view && view.matched && view.matched[1]) firstLevel = view.matched[1];

            // 判断有没有缓存过一级路由，如果缓存过代表只用修改realPath
            const tagIndex = state.visitedViews.findIndex(v => v.name === firstLevel.name);

            if (tagIndex >= 0) {
                state.visitedViews[tagIndex].realPath = view.fullPath;
            } else {
                state.visitedViews.push({
                    // 第一级路由信息
                    name: firstLevel.name,
                    path: firstLevel.path,
                    title: firstLevel.meta.title || '无标题',

                    // 真实的地址(因为该标签可能已经跳转到详情等二级页面)
                    realPath: view.fullPath,

                    // 页签$route对象
                    $tagRoute: firstLevel,
                });
            }

            // 替换历史缓存路由的navType
            if (state.visitedViews && state.visitedViews.length) {
                state.visitedViews.forEach((v) => {
                    v.realPath = v.realPath.replace(/navType=([^&]*)/, `navType=${view.query.navType || 'Homepage'}`);
                });
            }

            if (!firstLevel.meta.noCache && tagIndex < 0) {
                state.cachedViews.push(firstLevel.name);
            }
        },
        DEL_VISITED_VIEWS: (state, view) => {
            // eslint-disable-next-line
            for (const [i, v,] of state.visitedViews.entries()) {
                if (v.name === view.name) {
                    state.visitedViews.splice(i, 1);
                    break;
                }
            }
            for (const i of state.cachedViews) {
                if (i === view.name) {
                    const index = state.cachedViews.indexOf(i);
                    state.cachedViews.splice(index, 1);
                    break;
                }
            }

            // 删除页签重置已缓存的滚动条位置
            const tagSavedPosition = view.$tagRoute.meta.savedPosition;
            if (tagSavedPosition) {
                tagSavedPosition.x = 0;
                tagSavedPosition.y = 0;
            }
        },
        // DEL_OTHERS_VIEWS: (state, view) => {
        //     // eslint-disable-next-line
        //     for (const [i, v,] of state.visitedViews.entries()) {
        //         if (v.name === view.name) {
        //             state.visitedViews = state.visitedViews.slice(i, i + 1);
        //             break;
        //         }
        //     }
        //     for (const i of state.cachedViews) {
        //         if (i === view.name) {
        //             const index = state.cachedViews.indexOf(i);
        //             state.cachedViews = state.cachedViews.slice(index, i + 1);
        //             break;
        //         }
        //     }
        // },
        // DEL_ALL_VIEWS: (state) => {
        //     // 不删除首页
        //     const homePageRoute = state.visitedViews.find(v => /Homepage/.test(v.name));

        //     if (homePageRoute) {
        //         state.visitedViews = [
        //             homePageRoute,
        //         ];
        //         state.cachedViews = [
        //             homePageRoute.name,
        //         ];
        //     } else {
        //         state.visitedViews = [];
        //         state.cachedViews = [];
        //     }
        // },
    },
    actions: {
        AddVisitedViews({ commit }, view) {
            commit('ADD_VISITED_VIEWS', view);
        },
        DelVisitedViews({ commit, state }, view) {
            return new Promise((resolve) => {
                commit('DEL_VISITED_VIEWS', view);
                resolve([
                    ...state.visitedViews,
                ]);
            });
        },
        // DelOthersViews({ commit, state, }, view) {
        //     return new Promise((resolve) => {
        //         commit('DEL_OTHERS_VIEWS', view);
        //         resolve([
        //             ...state.visitedViews,
        //         ]);
        //     });
        // },
        // DelAllViews({ commit, state, }) {
        //     return new Promise((resolve) => {
        //         commit('DEL_ALL_VIEWS');
        //         resolve([
        //             ...state.visitedViews,
        //         ]);
        //     });
        // },
    },
};

export default tagsView;
